import { ForgeObject } from 'src/app/classes/viewer/objects/ForgeObject';
import { Metric } from 'src/app/interfaces/api/metric';
import { Model } from 'src/app/interfaces/api/model';
import { Config } from 'src/app/interfaces/shared/config';

export class MetricObject extends ForgeObject {
    metric: Metric;
    color: string;
    threeColor: THREE.Color;

    id: string;
    title?: string;
    weight?: number;
    startDate?: string;
    endDate?: string;
    startPosition: any;
    loadPosition: any;
    endPosition: any;
    tracker?: string;
    category?: string;
    constructor(metric: Metric, viewer: any, model: Model, options: any) {
        super(viewer, model, options);

        this.id = metric.id;
        this.weight = metric.payload['weight']
        this.startDate = metric.payload.startDate;
        this.endDate = metric.payload.endDate;
        this.title = metric.payload['prediction'];
        this.tracker = metric.tracker as string;
        this.metric = metric;
        this.color = metric.payload.color ?? Config.colors.default;
        
        this.threeColor = new THREE.Color(this.color);
        this.viewer.overlays.addMesh(this.mesh, "metrics");
    }

    update(params: { color?: string, visible?: boolean, selected?: boolean }): void {
        try {

            const meshMaterial = this.mesh.material as THREE.MeshPhongMaterial;
            // if (params.selected) {
            //     meshMaterial.emissive = new THREE.Color("#EEEEEE");
            //     meshMaterial.color = new THREE.Color("#EEEEEE");
            // } else {
            //     meshMaterial.color = this.threeColor; // TODO: params.color is not taken into account
            //     meshMaterial.emissive = this.threeColor;
            // }
            //
            // this.mesh.material.color = new THREE.Color("#a1a1a1");
            // this.viewer.impl.addOverlay("metric-" + this.mesh.material.name + this.threeColor, this.mesh);

        } catch (e) {
            console.error(e)
        }
    }
}